import { Box } from '@mui/material';
import React from 'react';

import { CardImageEnum } from './CardImageEnum';
import { CardImageSize } from './CardSizeEnums';

export interface ObjectCardImageProps {
  image?: CardImageEnum;
  imageSrc?: string;
  imageSize?: CardImageSize | number;
  width?: number;
}
export const ObjectCardImage: React.FC<ObjectCardImageProps> = ({
  image,
  imageSrc,
  imageSize = CardImageSize.LARGE,
  width,
}) => {
  const localStyle: Record<string, any> = { height: imageSize };

  if (width && width > 0) {
    localStyle['width'] = width + 'px';
  }

  // const { playerBasePath } = useEnvironment();

  //
  // after removing cardimages2 from ui-components, we tried to resolve all images
  // in the apps. This is not working for ObjectCardImages that are embedded in
  // other elements as we have to resolve it everywhere and backward-compatible
  // also in rendered sessions!
  // Of course, we could introduce the correspongind imageSrc prop for all these
  // components and resolve them in the apps, but this means high efforts and
  // is error prone in addition.
  // The most pragmatic way is to resolve the images here and build in a
  // dependency to future apps.
  // ! we are fully aware that this is a bad pattern but we actively accept that here
  // We may change this in future to get rid of this hack, e.g. to provide other
  // images to hot or not, etc.
  //
  // legacy call means: image prop with enum is set, but imageSrc is not yet resolved
  //
  // if (image && (!imageSrc || imageSrc === '')) {
  //   imageSrc = mapImageToPublicAsset(image, playerBasePath);
  // }

  return (
    <>
      <Box
        width="100%"
        height="100%"
        sx={{
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'contain',
          mixBlendMode: 'multiply',
        }}
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={localStyle}
      >
        {imageSrc !== undefined && (
          <img
            height={imageSize}
            src={imageSrc}
            alt={image + ''}
            onError={({ currentTarget }) => {
              currentTarget.onerror = null; // prevents looping
              currentTarget.src = '';
            }}
          ></img>
        )}
      </Box>
    </>
  );
};
